import React, { useMemo } from 'react';

import { ZoomBar, ZoomButton } from '../styles';
import { activeZoomStep, zoomLabel, zoomSteps } from '../zoomLevels';

interface Props {
  factor: number;
  maxFactor: number;
  label: string;
  onSelect: (factor: number) => void;
}

export const ZoomControl = ({
  factor,
  maxFactor,
  label,
  onSelect,
}: Props): JSX.Element | null => {
  const steps = useMemo(() => zoomSteps(maxFactor), [maxFactor]);

  // Sin recorrido de zoom no hay nada que ofrecer.
  if (steps.length < 2) return null;

  const active = activeZoomStep(steps, factor);

  return (
    <ZoomBar role="group" aria-label={label}>
      {steps.map((step) => (
        <ZoomButton
          key={step}
          type="button"
          $active={step === active}
          aria-pressed={step === active}
          onClick={() => onSelect(step)}
        >
          {zoomLabel(step)}
        </ZoomButton>
      ))}
    </ZoomBar>
  );
};
